const appConfig = {
  apiPrefix: "/api",
  authenticatedEntryPath: "/app/admin/dashboard",
  unAuthenticatedEntryPath: "/admin/sign-in",
  tourPath: "/admin/sign-in",
  enableMock: true,
  pagePerData: 10,
  mealPagePerData: 20,
};

export default appConfig;
